module.exports = __webpack_public_path__ + "static/media/3.1644e75d.png";